import React from 'react';
import ReactDOM from 'react-dom/client';

import WorkplaceSearch from './Workplaces/Search';

document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementById('frontend-workplaces-search')) {
        ReactDOM.createRoot(document.getElementById('frontend-workplaces-search')).render(
            <WorkplaceSearch settings={workplacesSearchData} />
        );
    }
});
